import React, { useCallback, useState } from 'react';
import { ButtonAction } from '@amzn/storm-ui-page-header';
import { ActionDropdownGroup, POSITION } from '../types';
import {
  ActionDropdownTrigger,
  StyledDropdownAction as DropdownAction,
  StyledMenuItemGroup,
  StyledMenuItemLink,
} from './styles';

export const ActionsDropdown: React.VFC<{
  id: string;
  groups?: ActionDropdownGroup[];
  label: string;
  position?: POSITION;
  selectedValue?: string;
  state: string;
  toolTip?: string;
  tooltipPosition?: POSITION;
  ariaLabel?: string;
}> = ({
  id,
  groups,
  label,
  position,
  toolTip,
  tooltipPosition,
  state,
  ariaLabel,
}) => {
  const [active, setActive] = useState(false);
  const isDisabled = state === 'DISABLED';
  const isLoading = state === 'LOADING';
  const singleLinkDropdown =
    groups?.length === 1 && groups[0].links?.length === 1;

  const onClick = useCallback(() => {
    if (!isDisabled) {
      setActive(!active);
    }
  }, [active, setActive]);

  const onClose = useCallback(() => {
    setActive(false);
  }, [setActive]);

  if (singleLinkDropdown) {
    const id = groups[0].id;
    const link = groups[0].links[0];
    const label = link.label ?? groups[0].label;

    return (
      <ButtonAction
        id={id}
        label={label}
        data-eventid={id}
        data-ccx-e2e-id={`aac-button-${id}`}
        disabled={isDisabled}
        onClick={() => {
          window.location.assign(link.url);
        }}
        aria-label={label}
        {...(toolTip?.length && {
          tooltipContent: toolTip,
          tooltipPosition: tooltipPosition,
          'aria-haspopup': true,
        })}
      />
    );
  }

  return (
    <DropdownAction
      id={id}
      disabled={isDisabled}
      loading={isLoading}
      helptipText={toolTip}
      helptipTextPosition={tooltipPosition}
      isOpen={active}
      onClick={onClick}
      onClose={onClose}
      position={position}
      trigger={
        <ActionDropdownTrigger
          disabled={isDisabled}
          aria-label={ariaLabel}
          data-ccx-e2e-id={`aac-action-${id}`}
        >
          {label}
        </ActionDropdownTrigger>
      }
    >
      {groups?.map((group) => (
        <StyledMenuItemGroup key={group.id}>
          {group.links?.map((link) => (
            <StyledMenuItemLink
              key={link.id}
              id={link.id}
              href={link.url}
              onClick={link.onClickCallback}
              disabled={link.isDisabled}
              target="_self"
            >
              {link.label}
            </StyledMenuItemLink>
          ))}
        </StyledMenuItemGroup>
      ))}
    </DropdownAction>
  );
};
